/* eslint-disable */
/**
 * Tabs component.
 * Tabs selection is triggered by clicks on the $trigger ('.js-tabs-item') element.
 *
 */

const $ = require('jquery');

const limitedTag = () => {
	$('.js-radio').on('click', function(){
		if( $(this).hasClass('js-limited') ){
			$('.js-limitedTxt').removeClass('is-hidden');
		} else {
			$('.js-limitedTxt').addClass('is-hidden');
		}
	});
};

module.exports = limitedTag;
